/* ==========================================================================
   Badge de reducere langa pret — istore24 (Yuva 12.0.0)
   De salvat ca assets/custom-price-badge.js si inclus in theme.liquid:
     <script src="{{ 'custom-price-badge.js' | asset_url }}" defer></script>

   Procentul e o scadere intre doua preturi, deci nu poate fi calculat din
   CSS. Aici nu exista atribute data- cu valorile, asa ca le citim din text.
   ========================================================================== */
(function () {
  'use strict';

  var BADGE_CLASS = 'yv-sale-badge';

  /* "1.299,00 lei" -> 1299 ; "De la 99,00 lei" -> 99
     Punctul e separator de mii in formatul RO, virgula e zecimala. */
  function toNumber(text) {
    if (!text) return null;
    var cleaned = text.replace(/[^\d.,]/g, '');
    cleaned = cleaned.replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.');
    var n = parseFloat(cleaned);
    return isNaN(n) ? null : n;
  }

  function process() {
    var boxes = document.querySelectorAll('.yv-prizebox');

    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      if (box.querySelector('.' + BADGE_CLASS)) continue;

      var oldEl = box.querySelector('.yv-product-compare-price');
      var newEl = box.querySelector('.yv-product-price');
      if (!oldEl || !newEl) continue;

      var oldPrice = toNumber(oldEl.textContent);
      var newPrice = toNumber(newEl.textContent);
      if (!oldPrice || !newPrice || oldPrice <= newPrice) continue;

      var pct = Math.round((oldPrice - newPrice) / oldPrice * 100);
      if (pct < 1) continue;

      var badge = document.createElement('span');
      badge.className = BADGE_CLASS;
      badge.setAttribute('aria-hidden', 'true');
      badge.textContent = '-' + pct + '%';

      /* Badge-ul trebuie sa fie copil DIRECT al .yv-prizebox, ca sa poata fi
         asezat cu "order" in CSS. Pe pagina de produs pretul vechi e invelit
         in .yv-compare-price-box, deci ne pozitionam dupa acel wrapper. */
      var anchor = oldEl;
      while (anchor.parentNode && anchor.parentNode !== box) {
        anchor = anchor.parentNode;
      }
      if (anchor.parentNode === box) {
        box.insertBefore(badge, anchor.nextSibling);
      } else {
        box.appendChild(badge);
      }
    }
  }

  function run() {
    try { process(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* Preturi randate din nou: schimbarea variantei, quick view, filtrare. */
  if (window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(run, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();